import React, { useEffect, useRef, useState } from "react";
import Spin from "../ui/Spin";
import ScrollWrap from "../ui/ScrollWrap";
import VirtualTable from "../ui/VirtualTable";
import { getRowFromJSON, parseCols } from "./ReportColumns";
import { pubCall } from "../utils/PubSub";
import { showError } from "../ui/Message";
import { KBD } from "../utils/Keybindings";
import { listen } from "../hooks/Listener";
import Cookies from "js-cookie";
import { SortIcon } from "../utils/Icons";

export default function ReportsInventoryList(props) {

    const { controller = "", view = "", reportSearch = "", 
        onSelectedRowClick = () => { },
        report = {}, switchView = () => { }, selected = {}, setSelected = () => { }, route = "", state = {}, setState = () => { }, header = "", fullData = {} } = props;
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const scrollRef = useRef();
    const columnRefs = useRef([]);
    const limit = 45;
    const [align, setAlign] = useState("auto");
    const buffer = 20;
    const [columns, setColumns] = useState(parseCols(report, true));
    const totalWidth = columns.reduce((sum, col) => sum + (Math.ceil(col.width) || 0), 0);
    const { cached_row_total = 0 } = report;

    const row_key = "stock_id";
    const [lastTab, setLastTab] = useState(state?.tabs === "expand" ? "history" : state.tabs);



    useEffect(() => {
        if (props.goto !== false) {
            getInitial(props.goto)
        }
    }, [props.goto])

    useEffect(() => {
        if (state?.tabs !== "expand") {
            setLastTab(state.tabs);
        }
    }, [state?.tabs])

    useEffect(() => {
        const cleanup = listen(controller, route, [
            {
                key: KBD.CTRL_HOME,
                action: () => { getInitial(1) },
            },
            {
                key: KBD.CTRL_END,
                action: () => { getInitial(cached_row_total) },
            },
         
        ]);

        return cleanup;
    }, [columns, columnRefs]);

    const [selectedColumn, setSelectedColumn] = useState(columns[0]?.key);

    const getInitial = (_start = false) => {
        if (reportSearch) return;
        setLoading(true);
        let _cookie = Cookies.get("reports_report_stock");
        let _obj = { report_id: report.report_id, limit: limit, offset: data.length }

        if (_cookie) {

            try {
                _cookie = JSON.parse(_cookie);
            } catch {
                _cookie = null;
            }
            if (_cookie?.report_id === report.report_id) {
                _obj.offset = _cookie.number;
            } else {
                _cookie = null;
            }
        }

        if (_start) {
            _obj.offset = _start;
        }

        setAlign("start");
        pubCall("report.getRowsInitial", _obj, (_s, _r) => {
            if (_s) {
                const _results = _r?.rows_previous.concat(_r?.rows_next).map(item => {
                    let _historical = getRowFromJSON(item, columns);
                    let _stock = item?.stock || {}
                    return { ..._historical, ..._stock, ...{ number: item.number } };
                }) || [];

                setData(_results);

                if (_results?.length > 0) {

                    let _ind = (_start) ? _start : _cookie?.number || 0;

                    if (_ind > 0) {
                        let _f = _results.findIndex(item => item.number === _ind);
                        if (_f > -1) {
                            setSelected(_results[_f])
                        } else {
                            // one more than the length to be first in rows_next array
                            setSelected(_results[_r?.rows_previous.length]);
                        }
                    } else {
                        setSelected(_results[_r?.rows_previous.length]);
                    }

                    setTimeout(() => {
                        setAlign("auto")
                    }, 10)

                }

            } else {

                if (_cookie) {
                    // Cookie failed, so re-run without the cookie
                    Cookies.set("reports_report_stock", "");
                    getInitial();
                    return;
                }

                showError(_r);
            }
            setLoading(false);
        })
    }

    useEffect(getInitial, []);


    useEffect(() => {


        if (!reportSearch) return;
        setLoading(true);
        pubCall("report.searchWithinKeyword", { report_id: report.report_id, limit: 40, keyword: reportSearch }, (_s, _r) => {

            if (_s) {
                const _results = _r?.rows_previous.concat(_r?.rows_next).map(item => {
                    let _historical = getRowFromJSON(item, columns);
                    let _stock = item?.stock || {}
                    return { ..._historical, ..._stock, ...{ number: item.number } };
                }) || [];

                setData(_results);
                setAlign("start");

                if (_results?.length > 0) {

                    setSelected(_results[_r?.rows_previous.length]);

                    setTimeout(() => {
                        setAlign("auto")
                    }, 10)

                }

            } else {

                showError(_r);
            }
            setLoading(false);

        })


    }, [reportSearch])

    const fetchNext = () => {
        setLoading(true);
        const last_item = data[data.length - 1] || {};
        let _obj = { report_id: report.report_id, limit: limit, offset: last_item.number }
        pubCall("report.getRowsNext", _obj, (_s, _r) => {
            if (_s) {
                const _results = _r?.map(item => {
                    let _historical = getRowFromJSON(item, columns);
                    let _stock = item?.stock || {}

                    return { ..._historical, ..._stock, ...{ number: item.number } };
                }) || [];
                setData(data.concat(_results));

            } else {
                showError(_r);
            }
            setLoading(false);
        })
    }

    const [loadingPrev, setLoadingPrev] = useState(false);
    const fetchPrev = () => {
        setLoading(true);
        setLoadingPrev(true);
        const first_item = data[0] || {};
        let _obj = { report_id: report.report_id, limit: limit, offset: first_item.number }

        pubCall("report.getRowsPrevious", _obj, (_s, _r) => {
            if (_s) {
                setAlign("start")
                const _results = _r?.map(item => {
                    let _historical = getRowFromJSON(item, columns);
                    let _stock = item?.stock || {}
                    return { ..._historical, ..._stock, ...{ number: item.number } };
                }) || [];



                // setSelected(first_item);


                setData(_results.concat(data));

            } else {
                showError(_r);
            }
            setLoading(false);

        })
    }




    useEffect(() => {
        if (selected) {
            Cookies.set("reports_report_stock", JSON.stringify({ report_id: report.report_id, number: selected?.number }));
        }
    }, [selected])


    const next = (_rows = 1) => {
        if (data.length === 0) { setSelected({}); return; }

        if(_rows > 1){
            setAlign("start")
        } else {
            setAlign("auto");
        }
        

        const nextIndex = data.findIndex(item => item?.[row_key] === selected?.[row_key]) + _rows;
        if (data.length <= nextIndex) {
            setSelected(data[data.length - 1]);
        }
        // Fetch chunk...

        if (nextIndex > data.length - buffer) {
            if (!loading) {
                fetchNext();
            }
        }

        if (nextIndex < data.length) {
            setSelected(data[nextIndex]);
        }
    };
    const prev = (_rows = 1) => {


        if (data.length === 0) { setSelected({}); return; }
        setAlign("auto");
        const prevIndex = data.findIndex(item => item?.[row_key] === selected?.[row_key]) - _rows;


        // Fetch chunk...
        if (prevIndex < 1) {

            if (!loading) {
                fetchPrev();
            }
        }

        if (prevIndex < 0) {
            setSelected(data[0]);
            return;
        }
        if (prevIndex >= 0) {
            setSelected(data[prevIndex]);
        }
    };


    const toggleExpanded = () => {

        if (state?.view === "inventory_full") {
            switchView("inventory")
        } else {
            switchView("inventory_full")
        }
    }


    useEffect(() => {
        const stock = fullData?.stock;
        if (!stock) return;
        if (!stock.stock_id) return;
        if (selected?.stock_id !== stock.stock_id) return;

        setData(prev => {
            let changed = false;
            // not sure if all rows match (non stock rows and weird ones like "number")
            const next = prev.map(row => {
                if (row.stock_id !== stock.stock_id) return row;
                const updated = { ...row };
                for (const key of Object.keys(stock)) {
                    if (key in row) {
                        updated[key] = stock[key];
                    }
                }
                changed = true;
                return updated;
            });

            return changed ? next : prev;
        });

    }, [fullData?.stock]);


    const chToPx = (_ch = 1, _addPad = true) => {
        let _pad = (_addPad) ? 10 : 0;
        return _ch * 9.3466 + _pad;
    }

    const swapColumn = (_selected, _target) => {
        setColumns(prev => {
            const from = prev.findIndex(col => col.key === _selected);
            const to = prev.findIndex(col => col.key === _target);

            if (from === -1 || to === -1) return prev;

            const next = [...prev];
            [next[from], next[to]] = [next[to], next[from]];
            return next;
        });
    };

    const onColumnResize = (_column, _delta, _width) => {
        if (_column !== selectedColumn) return;

        let updatedColumns;
        const amt = Math.round((_width + _delta) / 9.3466);

        setColumns(cols => {
            updatedColumns = cols.map(c => {
                if (c.key === selectedColumn) {
                    const minWidth = chToPx(1);
                    return {
                        ...c,
                        width: Math.max(chToPx(amt), minWidth)
                    };
                }
                return c;
            });
            return updatedColumns;
        });
    };



    return (
        <>

            {/* <Spin loading={loading}> */}
            {/* {props.state.tabs} */}
            <div style={{ display: (props?.hide) ? "none" : "block" }} className="ui-arrow-wrapper">
                <ScrollWrap allow_nudge={true} controller={controller} route={route} ref={scrollRef} reset={state?.view} width={1420}>

                    <VirtualTable
                        controller={controller}
                        header={<small>{header} {(reportSearch && <> &nbsp; - &nbsp; Searching: <span style={{ "color": "yellow" }}>{reportSearch}</span></>)}</small>}
                        monospace={false}
                        cursor="default"
                        ref={columnRefs}
                        columnInteractions={false}
                        setSelected={setSelected}
                        loadingPrev={loadingPrev}
                        // onColumnResize={onColumnResize}
                        className={(state?.view === "inventory" || state?.view === "inventory_full") ? "" : "dimmed"}
                        // onColDoubleClick={() => drawSwap()}
                        // reorderColumn={(selected, target) => swapColumn(selected, target)}
                        // onContext={(e) => handleContextMenu(e)}
                        // selectedColumn={selectedColumn}
                        // setSelectedColumn={setSelectedColumn}
                        // onColumnPositionChange={setColumnPosition}
                        // edit={edit}
                        // small={small}
                        // showColumnHeaders={showColumnHeaders}
                        // header={<Float><Label className="light" style={{ "textAlign": "left" }}>{header}</Label>{(show_add && <a onClick={() => kbdEvent(KBD.N)} style={{ "fontSize": "14px" }}>Add Filter +</a>)}</Float>}
                        // headerClass={headerClass}
                        onLoadMore={(_start, _end, _prepend) => {


                            if (_prepend) {
                                // prepend...
                                if (data?.length > 0 && data[0]?.number !== 1) {
                                    fetchPrev()
                                }
                            } else {
                                if (data?.length > 0) {
                                    fetchNext();
                                }

                            }
                        }}
                        

                        onRowClick={(item, event, index) => {
                          
                        if (item?.number === selected?.number && (state?.view == "inventory" || state?.view === "inventory_full")) {
                            onSelectedRowClick();
                        } else {
                            if(state.view !== "inventory" && state?.view !== "inventory_full"){
                                props.switchView("inventory")    
                            } else {
                                setAlign("auto"); setSelected(item)
                            }
                            
                            
                        }
                    }}

                        next={next}
                        prev={prev}
                        align={align}
                        row_key={row_key}
                        current={selected}
                        data={data}
                        columns={columns}
                        width={totalWidth}
                        loading={loading}
                        offset={448}
                        height={200}
                        scrollbar={true}
                        scrollindicator={true}
                        infinite={true}
                        route={route}
                    />

                </ScrollWrap>
                <div onClick={() => toggleExpanded()} className="ui-arrow">
                    <div style={{ "transform": (state?.view === "inventory_full") ? "rotate(90deg)" : "rotate(-90deg)", "marginRight": (state?.view === "inventory_full") ? "-5px" : "5px" }}>
                        <SortIcon />
                    </div>
                </div>
            </div>
            {/* </Spin> */}
        </>
    )
}